/**
 * @deprecated legacy sh!t, rewrite to normal routes A$AP
 */
export enum CoachCalendarStepUrls {
    LINK_CALENDAR_STEP = "/link-calendar",
    LINK_ACCOUNTS_STEP = "/link-accounts",
    AVAILABILITY_STEP = "/availability-step",
    AVAILABILITY_CONFIRM_STEP = "/availability-confirm-step",
    CALENDAR_ADD = "/add-calendar"
}
